import React from 'react'

type HoverHandlersProps = {
  setHovered: React.Dispatch<React.SetStateAction<boolean>>
  setPressed?: React.Dispatch<React.SetStateAction<boolean>>
}

type UseHoverHandlersRet = {
  onMouseEnter: () => void
  onMouseLeave: () => void
  onMouseDown: () => void
}

export const useHoverHandlers = ({
  setHovered,
  setPressed
}: HoverHandlersProps): UseHoverHandlersRet => {
  const onMouseEnter = (): void => {
    setHovered(true)
  }

  const onMouseLeave = (): void => {
    setHovered(false)
    setPressed?.(false)
  }

  const onMouseDown = (): void => {
    setPressed?.(true)
  }

  return {onMouseEnter, onMouseLeave, onMouseDown}
}
